var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.162 10.6667H12V12H0V9.17133L6.6 2.57133L9.428 5.40066L4.16133 10.6667H4.162ZM7.542 1.62933L8.95667 0.214661C9.08169 0.0896806 9.25122 0.0194702 9.428 0.0194702C9.60478 0.0194702 9.77432 0.0896806 9.89933 0.214661L11.7853 2.10066C11.9103 2.22568 11.9805 2.39522 11.9805 2.57199C11.9805 2.74877 11.9103 2.91831 11.7853 3.04333L10.3707 4.45733L7.54267 1.62933H7.542Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9ed191e5495c51a18205ee845d678bc8.svg";
export { ForwardRef as ReactComponent };